import { useAuth } from '@/features/auth/providers/AuthProvider/hooks';

import React from 'react';
import { useLocalStorage } from 'usehooks-ts';

interface IHighLightsContext {
  windowLoadCount: number;
}

const HighLightsContext = React.createContext<IHighLightsContext>({
  windowLoadCount: 0,
});
const HighLightsProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { user } = useAuth();

  const [windowLoadCount, setWindowLoadCount] = useLocalStorage<number>(
    `@User:${user?.id}:windowLoadCount`,
    0,
  );

  React.useEffect(() => {
    if (user) {
      setWindowLoadCount(prev => prev + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <HighLightsContext.Provider
      value={{
        windowLoadCount,
      }}
    >
      {children}
    </HighLightsContext.Provider>
  );
};

export function useHighLights(): IHighLightsContext {
  return React.useContext<IHighLightsContext>(HighLightsContext);
}

export default HighLightsProvider;
